import Actions                from 'Redux/Actions';
import { LocationRepository } from 'Domain/Repositories';
import { ofType }             from 'redux-observable';
import { from }               from 'rxjs';
import { mergeMap }           from 'rxjs/operators';
import { TEpic }              from 'Redux/Config';

export const findLocationsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findLocationsRequest.type),
    mergeMap(action => from(
      LocationRepository.findAll(action.payload)
        .then(({ locations, meta }) => Actions.findLocationsSuccess({ locations, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findLocationsFailure({ error })),
    )),
  );
};
